import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function getJobRoleMembers(jobId: string, roleId: string) {
	const response = await fetch(`${apiEndpoint}/jobs/${jobId}/roles/${roleId}/members`, {
		method: 'GET',
		headers: await standardHeaders(),
		mode: 'cors'
	});
	if (response.ok) {
		return await response.json();
	}
	return [];
}